module.exports = __webpack_public_path__ + "img/spetema.c519050b.svg";